<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="$router.go(-1)" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('Печать') }}
				</b-button>
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="doc-body">
			<b-card class="p-1">
				<template #header>
					<b-row style="width: 100%; margin-top: 20px">
						<b-col>
							<strong>Duty Free International</strong><br>
							<b>{{ $t('promo-to-product.invoice') }}</b> - {{ items.regNumber }}<br>
							<b>{{ $t('promo-to-product.regDate') }}</b> - {{ items.regDate }}<br>
							<b>{{ $t('incomeFilter.depFrom') }}</b> - {{ items.fromDepartmentName }}
						</b-col>
						<b-col>
							<b-card-title class="text-center">Расходно-приходная накладная передачи товаров в разлив</b-card-title>
						</b-col>
						<b-col/>
					</b-row>
				</template>
				<b-card-body>
					<b-row class="mt-3">
						<b-col>
							<table id="table" class="table-striped table-bordered table-hover" style="width: 100%">
								<thead>
								<tr>
									<th class="text-center">{{ '№' }}</th>
									<th class="text-center">{{ $t('goods.special-barcode') }}</th>
									<th class="text-center">{{ $t('goods.name') }}</th>
									<th class="text-center">{{ $t('goods.artikul') }}</th>
									<th class="text-center">{{ $t('goods.barcode') }}</th>
									<th class="text-center">{{ $t('incomes.create.price') }}</th>
									<th class="text-center">{{ $t('sale.kol-vo') }}</th>
								</tr>
								</thead>
								<tbody v-for="(item, index) in items.whItems" :key="`table-items-${index}`">
								<tr>
									<td class="text-center">{{ index+1 }}</td>
									<td class="text-center">{{ item.barcode }}</td>
									<td class="text-left">{{ item.itemName }}</td>
									<td class="text-center">
										<div v-for="(vendor, index) in item.vendorCodes" :key="`vendors-${index}`">
											{{ vendor.vendor }}
										</div>
									</td>
									<td class="text-center">
										<span v-for="(barcode,i) in item.multiBarcodesString" :key="`barcode-${i}`" class="ml-1">{{ barcode }}</span>
									</td>
									<td class="text-center">$ {{ item.priceUzs }}</td>
									<td class="text-center">{{ item.count }}</td>
								</tr>
								<tr>
									<td colspan="7">
										<table style="width: 99%; margin: 10px">
											<thead>
											<tr>
												<th class="text-center">{{ '№' }}</th>
												<th class="text-center">{{ $t('goods.special-barcode') }}</th>
												<th class="text-center">{{ $t('goods.name') }}</th>
												<th class="text-center">{{ $t('incomes.create.price') }}</th>
												<th class="text-center">{{ $t('sale.kol-vo') }}</th>
												<th class="text-center">{{ $t('warehouse.item.total') }}</th>
											</tr>
											</thead>
											<tbody>
											<tr v-for="(child, ind) in item.wrappedItems" :key="`child-${ind}`">
												<td class="text-center">{{ ind+1 }}</td>
												<td class="text-center">{{ child.barcode }}</td>
												<td class="text-center">{{ child.name }}</td>
												<td class="text-center">$ {{ child.priceUzs }}</td>
												<td class="text-center">{{ child.amount }}</td>
												<td class="text-center">{{ child.amount * item.count }}</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
								<tbody v-if="items.whItems && items.whItems.length === 0">
								<tr>
									<td colspan="9" class="text-center"><h4>{{ $t('empty') }}</h4></td>
								</tr>
								</tbody>
							</table>
						</b-col>
					</b-row>
				</b-card-body>
				<div class="mb-3">
					<div v-if="loader" class="spinner-wrapper">
						<b-spinner variant="primary"></b-spinner>
					</div>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
import WhDocument from "../../../services/wh-document.service";

export default {
	name: "view",
	data() {
		return {
			items: {},
			loader: false
		}
	},
	methods: {
		print() {
			window.print();
		},
		getById() {
			WhDocument.get(this.$route.params.id).then(res => {
				this.items = res.data
			})
		}
	},
	created() {
		this.getById();
	}
}
</script>

<style scoped>
@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
}
</style>
